module.exports = __webpack_public_path__ + "static/media/events in poland 2cz.3dbb4bb2.mp4";